import classNames from "classnames";
import { DetailCard } from "components/molecules/TIle";
import { Spinner } from "components/atoms/Icon";
import { FetchError } from "components/molecules";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  "1": boolean;
  "2": boolean;
  "3": boolean;
  "4": boolean;
}

interface IProps {
  selectedBtn?: SelectedBtnState;
  selectedSession?: null | string | { [key: number]: string };
  data?: any;
  theme: "light" | "dark";
  isLoading?: boolean;
  isError?: boolean;
  isFetching?: boolean;
}

export const DetailCardSection = ({
  selectedBtn,
  selectedSession,
  data,
  theme,
  isLoading,
  isError,
  isFetching,
}: IProps) => {
  return (
    <div className={classNames("detail-card-section-wrapper")}>
      {isLoading ? (
        <Spinner theme={theme} />
      ) : isError ? (
        <FetchError content="Oops! failed to load resources." />
      ) : (
        data &&
        Array.isArray(data) &&
        data.map((item: any, index: number) => (
          <DetailCard
            key={`${index}-${item?.ProductOfferingSegmentId}`}
            borderColor={
              item.IsTestSegment
                ? "green"
                : item.IsTopicFocusSegment
                  ? "pink"
                  : "black"
            }
            isTabShow={
              item.Categories && Object.keys(item.Categories).length > 0
            }
            groups={item.Categories}
            title={item.Description}
            startTime={item.StarttimeUTC}
            endTime={item.EndtimeUTC}
            timeSpan={item.timeSpan}
            profileImage={item.InstructorPhotoUrl}
            name={item.InstructorName}
            email={item.InstructorEmail}
            messageIcon={true}
            userGuid={item?.ExamCo?.InstanceGuid}
            contentObjectGuid={item?.ExamCo?.ContentObjectGuid}
            contentObjectType={item?.ExamCo?.ContentObjectType}
            segmentObj={item}
            theme={theme}
            index={index}
            itemPageNo={item.page}
          />
        ))
      )}
    </div>
  );
};
